import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Truck, Lock } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24">
      <div className="blz-container py-14 grid gap-10 md:grid-cols-4">
        <div>
          <Logo size="md" theme="dark" />
          <p className="text-sm text-slate-400 leading-relaxed mt-4">
            Certified pharmaceutical solutions delivered in verified pack sizes. Licensed pharmacist review on every order.
          </p>
          <div className="mt-4 flex flex-wrap gap-3 text-xs text-slate-400">
            <div className="flex items-center gap-1"><ShieldCheck className="h-4 w-4 text-emerald-500"/> Licensed</div>
            <div className="flex items-center gap-1"><Truck className="h-4 w-4 text-emerald-500"/> Discreet shipping</div>
            <div className="flex items-center gap-1"><Lock className="h-4 w-4 text-emerald-500"/> Secure checkout</div>
          </div>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalogue" className="hover:text-white">All Products</Link></li>
            <li><Link to="/category/pain-relief" className="hover:text-white">Pain Relief</Link></li>
            <li><Link to="/category/antibiotics" className="hover:text-white">Antibiotics</Link></li>
            <li><Link to="/category/vitamins" className="hover:text-white">Vitamins</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3">Support</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/shipping" className="hover:text-white">Shipping Info</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact Support</Link></li>
            <li><Link to="/prescription-info" className="hover:text-white">Prescription Info</Link></li>
            <li><Link to="/payment-options" className="hover:text-white">Payment Options</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms & Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="blz-container py-5 text-xs text-slate-500 flex flex-wrap gap-2 justify-between">
          <div>© {new Date().getFullYear()} Noyaa Pharma. All rights reserved.</div>
          <div>For informational purposes. Consult a licensed physician for medical advice.</div>
        </div>
      </div>
    </footer>
  );
}
